import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import formatCmsImageUrl from '../../../services/formatCmsImageUrl';
import styled, { css, keyframes } from 'styled-components';
import { colorPalette, CUBIC_TIMING, loadInAnimation } from '../../../styles/styleGuide';
import Observer from 'react-intersection-observer';
var WIDTH_SIZES = [50, 70, 100, 200, 400, 800, 1200, 1400, 1900, 2500, 3100, 3840];
var getSize = function getSize(width) {
  return WIDTH_SIZES.reduce(function (prev, curr) {
    return Math.abs(curr - width) < Math.abs(prev - width) ? curr : prev;
  });
};
var ImageLoader = /*#__PURE__*/function (_React$PureComponent) {
  function ImageLoader() {
    var _this;
    _classCallCheck(this, ImageLoader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ImageLoader, [].concat(args));
    _defineProperty(_this, "state", {
      loaded: false,
      isClient: false
    });
    _defineProperty(_this, "setLoaded", function () {
      var loaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return _this.setState({
        loaded: loaded
      });
    });
    return _this;
  }
  _inherits(ImageLoader, _React$PureComponent);
  return _createClass(ImageLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isClient: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps) {
      if (newProps.src !== this.props.src) {
        this.setLoaded(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props,
        state = this.state,
        setLoaded = this.setLoaded;
      var src = props.src,
        alt = props.alt,
        color = props.color,
        mode = props.mode,
        fit = props.fit,
        position = props.position,
        scaleTransition = props.scaleTransition,
        width = props.width,
        _props$height = props.height,
        height = _props$height === void 0 ? 0 : _props$height,
        rectangular = props.rectangular;
      var loaded = state.loaded,
        isClient = state.isClient;
      var imageSize = width !== undefined ? getSize(width) : 0;
      var imageUrl = imageSize ? formatCmsImageUrl(imageSize, height, src, rectangular) : src;
      return isClient ? __jsx(Observer, {
        "data-id": "ui_ImageLoader_Observer"
      }, function (_ref) {
        var inView = _ref.inView,
          ref = _ref.ref;
        return __jsx(Wrapper, _extends({
          position: position,
          scaleTransition: scaleTransition
        }, props, {
          src: undefined,
          ref: ref,
          "data-id": "ui_ImageLoader_Wrapper"
        }), (mode === 'img' || mode === 'bg' && !loaded && inView) && __jsx(Image, {
          src: imageUrl,
          alt: alt || 'plaatje',
          onLoad: setLoaded,
          mode: mode,
          loaded: loaded,
          "data-id": "ui_ImageLoader_Image"
        }), mode === 'bg' && loaded && __jsx(BGImage, {
          fit: fit,
          src: imageUrl,
          onLoad: setLoaded,
          loaded: loaded,
          "data-id": "ui_ImageLoader_BGImage"
        }), __jsx(LoadPlaceholder, {
          color: color,
          deactivated: loaded,
          "data-id": "ui_ImageLoader_LoadPlaceholder"
        }));
      }) : null;
    }
  }]);
}(React.PureComponent);
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: ", ";\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  z-index: 2;\n  ", ";\n"])), function (props) {
  return props.position === 'absolute' ? props.position : 'relative';
}, function (props) {
  return props.scaleTransition && "\n    transform: scale(1.005) translateZ(0);\n    transition: transform 1s ease;\n    will-change: transform;\n    backface-visibility: hidden;\n  ";
});
var loaderStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n"])));
var Image = styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  display: block;\n  position: relative;\n  z-index: 1;\n  visibility: ", ";\n  opacity: 0;\n  animation: ", ";\n  animation-fill-mode: forwards;\n"])), loaderStyles, function (props) {
  return props.mode === 'img' ? 'visible' : 'hidden';
}, function (props) {
  return props.loaded ? css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          ", " 0.7s ", "\n        "])), loadInAnimation, CUBIC_TIMING) : '';
});
var BGImage = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  height: 100%;\n  z-index: 1;\n  background-image: ", ";\n  background-size: ", ";\n  background-repeat: no-repeat;\n  background-position: center;\n  opacity: 0;\n  animation: ", ";\n  animation-fill-mode: forwards;\n"])), loaderStyles, function (props) {
  return "url(".concat(props.src, ")");
}, function (props) {
  return props.fit ? props.fit : 'cover';
}, function (props) {
  return props.loaded ? css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          ", " 0.7s ", "\n        "])), loadInAnimation, CUBIC_TIMING) : '';
});
var LoadPlaceholder = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  z-index: 1;\n  opacity: 1;\n  height: 100%;\n  background: ", ";\n  animation: ", ";\n  animation-fill-mode: forwards;\n"])), loaderStyles, function (props) {
  return props.color ? props.color : colorPalette.background;
}, function (props) {
  return props.deactivated ? css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          ", " 0.7s ease-in\n        "])), placeholderAnimation) : '';
});
var placeholderAnimation = keyframes(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n    z-index: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n    z-index: 0;\n  }\n"])));
export default ImageLoader;